export const calculatePercentage = (percent, totalValue) => {
    return (percent / 100) * totalValue;
}